// Ana sayfanın stil dosyaları (sürüm parametreleriyle). LandingPage ve BlogPage aynı adresleri
// kullanır; scripts/build-blog.mjs de bu dosyadan okur. Bir dosya değişince burada sürümü artır.
export const LANDING_STYLE_HREFS = {
  base: '/premium-landing.css?v=20261004-header-anchor',
  dashboard: '/premium-landing-dashboard.css?v=20260717-chat-viewport1',
  mobileFonts: '/premium-landing-mobile-fonts.css?v=20260920-pricing-currency',
  mobileLayout: '/premium-landing-mobile-layout.css?v=20261003-box-fade',
};

// Blog stili (yalnız blog sayfalarında yüklenir). Dosya değişince sürümü artır.
export const BLOG_STYLE_HREF = '/blog.css?v=20261003-library';

export const LANDING_STYLE_LIST = [
  LANDING_STYLE_HREFS.base,
  LANDING_STYLE_HREFS.dashboard,
  LANDING_STYLE_HREFS.mobileFonts,
  LANDING_STYLE_HREFS.mobileLayout,
];
